module.exports = __webpack_public_path__ + "img/Digrab_Carrousel_2.6d3d24c0.png";